import { render } from "./createOrganizationForm.vue?vue&type=template&id=6d21414a&scoped=true"
import script from "./createOrganizationForm.vue?vue&type=script&lang=js"
export * from "./createOrganizationForm.vue?vue&type=script&lang=js"

import "./createOrganizationForm.vue?vue&type=style&index=0&id=6d21414a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d21414a"]])

export default __exports__